import store from '@/store'
import { validateLink, parseMailHref, assembleMailHref } from '@/utils/String'
import { getHrefElm } from '@/components/Content/Palette/EditPartDesign/Editor/TinyMceEditor/Util'

// 通常リンク挿入・編集
const setup = function (editor) {
  editor.ui.registry.addIcon(
    'custom_link',
    '<svg width="24" height="24"><path d="M6.2 12.3a1 1 0 011.4 1.4l-2.1 2a2 2 0 102.7 2.8l4.8-4.8a1 1 0 000-1.4 1 1 0 111.4-1.3 2.9 2.9 0 010 4L9.6 20a3.9 3.9 0 01-5.5-5.5l2-2zm11.6-.6a1 1 0 01-1.4-1.4l2-2a2 2 0 10-2.6-2.8L11 10.3a1 1 0 000 1.4A1 1 0 119.6 13a2.9 2.9 0 010-4L14.4 4a3.9 3.9 0 015.5 5.5l-2 2z" fill-rule="nonzero"></path></svg>'
  )

  editor.ui.registry.addToggleButton('customLink', {
    icon: 'custom_link',
    onAction: (api) => {
      editor.execCommand('customLink')
    },
    onSetup: (buttonApi) => {
      // メニューボタンの状態を管理
      const editorEventCallback = (eventApi) => {
        const hrefElm = getHrefElm(editor, eventApi.element)
        if (hrefElm) {
          buttonApi.setActive(hrefElm)
        } else {
          buttonApi.setActive(false)
          buttonApi.setDisabled(false)
        }
      }
      editor.on('NodeChange', editorEventCallback)
      return function (buttonApi) {
        editor.off('NodeChange', editorEventCallback)
      }
    },
  })

  editor.addCommand('customLink', () => {
    let currentTabName = 'web'
    let selectedText = editor.selection.getContent({ format: 'text' })

    const hrefElm = getHrefElm(editor, editor.selection.getNode())
    if (!hrefElm && editor.selection.isCollapsed()) {
      // リンク文字列を選択していない、かつ、カーソルが何も選択していない時
      selectedText = ''
    } else if (!selectedText) {
      selectedText = editor.selection.getNode().innerText
    }

    let selectedBody = selectedText // リンク元テキストのみ共通
    let selectedWebLink = ''
    let selectedWebTitle = ''
    let selectedWebTarget = ''
    let selectedEmailTo = ''
    let selectedEmailSubject = ''
    let selectedEmailBody = ''
    let selectedTelLink = ''
    let selectedTelNumber = ''
    let selectedTelTitle = ''

    if (hrefElm) {
      let selectedHrefUuid = hrefElm.getAttribute('href')
      // 別のTinyMCE からの切替後にUUID が取得される場合があるので
      // store から取得して正しい href を表示させる
      let selectedHref = JSON.parse(JSON.stringify(selectedHrefUuid)) // ハードコピー
      const hrefsArray = store.state.status.tinyMceHrefs
      if (hrefsArray.map(href => { return href.uuid }).includes(selectedHref)) {
        let storedHref = hrefsArray.find(href => href.uuid === selectedHref).href
        selectedHref = storedHref
      }

      if (selectedHref) {
        // リンク編集ダイアログの初期値用
        if (selectedHref.startsWith('mailto:')) {
          currentTabName = 'email'
          const parsedMailHref = parseMailHref(selectedHref)
          selectedEmailTo = parsedMailHref.to
          selectedEmailSubject = parsedMailHref.subject
          selectedEmailBody = parsedMailHref.body
        } else if (selectedHref.startsWith('tel:')) {
          currentTabName = 'tel'
          selectedTelLink = selectedHref
          const telMatches = selectedTelLink.match(/^(tel:)([^.]+)/)
          const telNumber = telMatches[2] // tel: を抜いたもの
          if (telNumber) {
            selectedTelNumber = telNumber
          }
          selectedTelTitle = hrefElm.getAttribute('title') || ''
        } else {
          currentTabName = 'web'
          selectedWebLink = selectedHref
          selectedWebTitle = hrefElm.getAttribute('title') || ''
          selectedWebTarget = hrefElm.getAttribute('target') && hrefElm.getAttribute('target') === '_blank' ? 'new' : 'current'
        }
      }
    }

    // 選択状態の node を取得
    editor.windowManager.open({
      title: 'リンクの挿入・編集',
      body: {
        title: 'リンクの挿入・編集',
        type: 'tabpanel',
        tabs: [
          {
            name: 'web',
            title: 'WebサイトURL',
            type: 'form',
            items: [
              {
                name: 'body',
                type: 'input',
                label: 'リンク元テキスト',
              },
              {
                name: 'webLink',
                type: 'input',
                label: 'リンク先URL',
              },
              {
                name: 'webTitle',
                type: 'input',
                label: 'タイトル'
              },
              {
                name: 'webTarget',
                type: 'listbox',
                label: 'リンクの開き方',
                items: [
                  { text: '同じウィンドウ', value: 'current' },
                  { text: '新規ウィンドウ', value: 'new' },
                ],
              }
            ]
          },
          {
            name: 'email',
            title: 'メールアドレス',
            type: 'form',
            items: [
              {
                name: 'body',
                type: 'input',
                label: 'リンク元テキスト',
              },
              {
                name: 'emailTo',
                type: 'input',
                label: 'メールアドレス',
              },
              {
                name: 'emailSubject',
                type: 'input',
                label: 'メールタイトル',
              },
              {
                name: 'emailBody',
                type: 'textarea',
                label: 'メール本文'
              },
            ]
          },
          {
            name: 'tel',
            title: '電話番号',
            type: 'form',
            items: [
              {
                name: 'body',
                type: 'input',
                label: 'リンク元テキスト',
              },
              {
                name: 'telNumber',
                type: 'input',
                label: '電話番号',
              },
              {
                name: 'telTitle',
                type: 'input',
                label: 'タイトル'
              },
            ]
          },
        ]
      },
      buttons: [
        {
          type: 'cancel',
          text: 'Close'
        },
        {
          type: 'submit',
          text: 'Save',
          primary: true
        }
      ],
      initialData: {
        body: selectedBody,
        webLink: selectedWebLink,
        webTitle: selectedWebTitle,
        webTarget: selectedWebTarget,
        emailTo: selectedEmailTo,
        emailSubject: selectedEmailSubject,
        emailBody: selectedEmailBody,
        telNumber: selectedTelNumber,
        telTitle: selectedTelTitle,
      },
      onTabChange: (api, details) => {
        currentTabName = details.newTabName
      },
      onSubmit: (api) => {
        let data = api.getData()
        const errorMessages = validateLink(currentTabName, data)
        if (errorMessages.length !== 0) {
          store.commit('showErrorMessagePopup', errorMessages)
        } else {
          onSubmitAction(editor, data, currentTabName)
          api.close()
        }
      }
    })
  })
}

const onSubmitAction = (editor, data, tabName) => {
  const oldContent = editor.selection.getContent({ format: 'text' })

  let newHref
  if (tabName === 'web') {
    newHref = data.webLink
  } else if (tabName === 'email') {
    newHref = assembleMailHref(data.emailTo, data.emailSubject, data.emailBody)
  } else if (tabName === 'tel') {
    newHref = `tel:${data.telNumber}`
  }

  const newUuid = Math.random().toString(32).substring(2)
  // TinyMCEが undo や redo したときのために、データ更新前のストアのデータを削除しないで追加している
  store.commit('insertTinyMceHrefs', {
    uuid: newUuid,
    newHref: newHref
  })

  if (tabName === 'web') {
    data.webLink = newUuid
  } else if (tabName === 'email') {
    data.emailHref = newUuid
  } else if (tabName === 'tel') {
    data.telHref = newUuid
  }

  const hrefElm = getHrefElm(editor, editor.selection.getNode())

  if (oldContent) {
    // 更新(リンクでない文字列を範囲選択時)
    let newNode = document.createElement('a')
    updateLinkNode(newNode, data, tabName)
    editor.selection.setContent(newNode.outerHTML)
  } else if (hrefElm && editor.selection.getNode().innerText && editor.selection.getNode().innerText !== '\n') {
    // 更新(リンク文字列選択状態)
    updateLinkNode(hrefElm, data, tabName)
  } else {
    // 新規追加(文字列を選択していない時)
    let newNode = document.createElement('a')
    updateLinkNode(newNode, data, tabName)
    editor.insertContent(newNode.outerHTML)
  }
  // undoリストに追加
  editor.undoManager.add()
}

const updateLinkNode = (node, data, tabName) => {
  node.innerText = data.body
  // 更新(カーソルがリンク内にある場合)
  if (tabName === 'web') {
    node.href = data.webLink
    node.title = data.webTitle
    // data-mce-href を指定するとリンクの処理が TinyMCE で行われてしまうので指定しない
    if (data.webTarget === 'current') {
      node.target = '_top'
    } else {
      node.target = '_blank'
      node.rel = 'noopener'
    }
  }
  if (tabName === 'email') {
    node.href = data.emailHref
  }
  if (tabName === 'tel') {
    node.href = data.telHref
    node.title = data.telTitle
  }
  return node
}

export default { setup }
